export default __webpack_public_path__ + "static/media/de5a10.1f45f2a9.svg";